///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const TruckloadIcon = ({
  height,
  title = messages.truckload.defaultMessage,
  width,
  fill = "#343434",
  secondaryFill = "#ADAFB2",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="truckload-icon">{title}</title>
    <g fill="none" fillRule="evenodd">
      <path
        d="M50.7009111 14.911134h-8.333695V6.53894637h2.8217978l3.871005 3.71910143h1.6408922v4.6530862zM24.4710052 0H0l3.40389972 3.27184103H38.9641378V14.9127126H0l3.40581633 3.271841h4.1530205c-.23601685.3612285-.37784601.7848104-.37784601 1.2428576 0 1.299686 1.09630104 2.3525894 2.44860643 2.3525894 1.35038875 0 2.44641605-1.0529034 2.44641605-2.3525894 0-.4580472-.1423768-.8816291-.3775722-1.2428576h2.0899265c-.2354693.3612285-.3772984.7848104-.3772984 1.2428576 0 1.299686 1.0957534 2.3525894 2.4458684 2.3525894 1.352853 0 2.4488802-1.0529034 2.4488802-2.3525894 0-.4580472-.1421029-.8816291-.3775722-1.2428576h9.3571648c-.235743.3612285-.3775722.7848104-.3775722 1.2428576 0 1.299686 1.0976701 2.3525894 2.4494279 2.3525894 1.3506625 0 2.4466898-1.0529034 2.4466898-2.3525894 0-.4580472-.1415554-.8816291-.3770246-1.2428576h2.0888313c-.2354693.3612285-.3772984.7848104-.3772984 1.2428576 0 1.299686 1.0957534 2.3525894 2.4458684 2.3525894 1.3525792 0 2.4488802-1.0529034 2.4488802-2.3525894 0-.4580472-.1418291-.8816291-.3775722-1.2428576h6.8874757c-.2354693.3612285-.3772984.7848104-.3772984 1.2428576 0 1.299686 1.0960272 2.3525894 2.4466898 2.3525894 1.3520316 0 2.4480588-1.0529034 2.4480588-2.3525894 0-.4580472-.1418291-.8816291-.3772984-1.2428576h5.4242807V6.98620672h-4.1141407L46.599639 3.26736843h-4.2324229V0H24.4710052z"
        fill={fill}
      />
      <path
        fill={secondaryFill}
        d="M12.2651621 12.8700004h24.3772918V5.61000017H4.83503264z"
      />
    </g>
  </svg>
);

export default TruckloadIcon;
